import React, { useEffect, useRef } from "react";
import classes from "./GooglePay.module.scss";
import { PAYMENT_METHOD_TYPE } from "utility/utils";
import { useGooglePay } from "hooks/useGooglePayLoader";

interface GooglePayProps {
  amount?: number;
  onTokenReceived: (payload: object) => void;
}

export const GooglePay: React.FC<GooglePayProps> = ({
  amount,
  onTokenReceived,
}) => {
  const validAmount = typeof amount === "number" && !isNaN(amount) ? amount : 0;
  const { loadPaymentData, ready, paymentsClient } = useGooglePay(validAmount);
  const buttonRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ready || !paymentsClient || !buttonRef.current) return;

    // Clean up any previously rendered button
    buttonRef.current.innerHTML = "";

    // Create the Google Pay button with the official API
    const button = paymentsClient.createButton({
      buttonColor: "black",
      buttonType: "short",
      onClick: handleGooglePayClick,
      // You can set locale if needed: locale: "en-US"
    });

    buttonRef.current.appendChild(button);
    // Only re-run if ready,paymentsClient,  or amount changes
  }, [ready, paymentsClient, amount]);

  const handleGooglePayClick = () => {
    try {
      // Call loadPaymentData (which should use the static config in your hook)
      loadPaymentData()
        .then(function (res: any) {
          // paymentToken = res.paymentMethodData.tokenizationData.token;
          // If your API returns a token, extract and pass it back.
          // You may need to adjust this structure based on your gateway response
          console.log("Token response:", res);
          const googleToken = res.paymentMethodData;
          // res.paymentMethodData.tokenizationData.token;

          onTokenReceived({
            token: googleToken,
            walletType: 1,
            paymentMethodType: PAYMENT_METHOD_TYPE.eWallet,
          });
        })
        .catch(console.error);
    } catch (err) {
      console.error("Google Pay error", err);
      alert("Google Pay failed to load");
    }
  };

  if (!ready || paymentsClient === null) {
    return <div className={classes.Loading}>Loading Google Pay...</div>;
  }

  return <div ref={buttonRef} />;
};
